import { LinkContent } from "../../../LinkDataInterface";
import {
  faUserSecret,
  faCompassDrafting,
  faChampagneGlasses,
  faCalendar,
  faPeopleRoof,
  faUsersRectangle,
  faVestPatches,
  faPlaneDeparture,
  faBuildingColumns,
  faUserCheck,
  faMicrophone,
  faRunning,
  faUserNinja,
  faSignHanging,
  faSignature,
  faMoneyBill1Wave,
  faScaleBalanced,
  faMessage,
  faSackDollar,
  faPersonMilitaryPointing,
  faDoorOpen,
  faFileWaveform,
  faWalkieTalkie,
  faClipboardUser,
  faFingerprint,
  faCircleInfo,
  faClock,
  faFileShield,
  faHouseFire,
  faDrum,
  faCommentDollar,
  faFileInvoiceDollar,
  faMoneyBillTransfer,
} from "@fortawesome/free-solid-svg-icons";

/* Edition 2026 */

/**** Documents généraux ****/
// Ordre du jour
export const odjPleniaire: LinkContent = {
  faLogo: faUsersRectangle,
  title: "OdJ Pléniaire 2026",
  link: "https://docs.google.com/document/d/1KxYJgJtFWkFoGLVXYEjAs9TxqKzR4VUHyNu4P60ucRw",
};
export const odjTech: LinkContent = {
  faLogo: faVestPatches,
  title: "OdJ Technique 2026",
  link: "https://docs.google.com/document/d/1cX9ErtjXUzk5UyjraoQSEvTUFxWlih0e7wDwuDUmiT4",
};
export const odjAnim: LinkContent = {
  faLogo: faPlaneDeparture,
  title: "OdJ Animation 2026",
  link: "https://docs.google.com/document/d/16eI2wlDO64-MRBNMhLK6xh1gyg6OoZMeSssXlyB9WJg",
};
export const odjPres: LinkContent = {
  faLogo: faBuildingColumns,
  title: "OdJ Présidence 2026",
  link: "https://docs.google.com/document/d/1K0WStJxrvSRQCNT0PfH67H0i6XQpvWzSND8juYHRZjY",
};
export const odjPromo: LinkContent = {
  faLogo: faMicrophone,
  title: "OdJ Promotion 2026",
  link: "https://docs.google.com/document/d/1-s-nMm24_v5bgrbahZjxuCIOgtvHpAtbfcc2SI5zyjA",
};

// Documents communs
export const listComity: LinkContent = {
  faLogo: faPeopleRoof,
  title: "Liste comité 2026",
  link: "https://docs.google.com/spreadsheets/d/1nPYuJHwAOTNvEPgIGvzBXoQI1dk_GO1nMrtoMPERE-A/",
};
export const hoursSheet: LinkContent = {
  faLogo: faClock,
  title: "Doc des heures 2025",
  link: "",
};

// Semaine de montage et Japan-Impact
export const folderDynamic: LinkContent = {
  faLogo: faFileWaveform,
  title: "Document dynamique",
  link: "https://drive.google.com/drive/folders/1DKQ3bZQIHPHvBe0OanFbuaDma5GclQhA",
};
export const planningComite: LinkContent = {
  faLogo: faUserCheck,
  title: "Planning comité",
  link: "",
};

/**** Animations ****/
export const suiviAnim: LinkContent = {
  faLogo: faChampagneGlasses,
  title: "Suivit anim 2026",
  link: "https://docs.google.com/spreadsheets/d/1HebMnV_yrcEFcrtFhVEKs1lkmFA8I1PZkIINKlUrQYo",
};
export const planningParSalle: LinkContent = {
  faLogo: faCalendar,
  title: "Planning par salle 2026",
  link: "https://docs.google.com/spreadsheets/d/1cwT9iiI6Y_DERBkwtyW-6CVEnQhfNkw-XTukkBfwXUM",
};

// Activités
export const folderActivities: LinkContent = {
  faLogo: faRunning,
  title: "Activités 2026 (dossier)",
  link: "https://drive.google.com/drive/folders/1oCZchFTLbb5yIP-cs0UzZL2LslnSfK78",
};
export const suiviActivities: LinkContent = {
  faLogo: faUserNinja,
  title: "Suivit activités 2026",
  link: "https://docs.google.com/spreadsheets/d/1dmgLS1QaumgHuf8R9IBtbjRRMxJHoecnG0hsdoseGDk",
};

// Concert
export const suiviConcert: LinkContent = {
  faLogo: faDrum,
  title: "Suivi concert",
  link: "https://docs.google.com/spreadsheets/d/1ChRs5jlXJE7nlOX9luMF6d1myWKe_9bK1_c2LcnfDLE",
};

/**** Technique ****/
export const besoinTech: LinkContent = {
  faLogo: faCompassDrafting,
  title: "Besoin tech 2026",
  link: "https://docs.google.com/spreadsheets/d/1XszaHk3T2WixXygJSHgmyUmxIaIgne_W5w4ykugNfgY",
};
export const deadlineTech: LinkContent = {
  faLogo: faSignHanging,
  title: "Deadlines Tech 2026",
  link: "https://docs.google.com/spreadsheets/d/12DAW5n_k_q-PsfDhLhahxD2EQETcMQ8JnGLIfzh-kkA/",
};

// Sécurité
export const folderSecurity: LinkContent = {
  faLogo: faUserSecret,
  title: "Sécurité 2026 (dossier)",
  link: "https://drive.google.com/drive/folders/1fGTGm1dghWuE0UqqPOmVF3fNrve_VAPQ",
};
export const emergencyUsage: LinkContent = {
  faLogo: faHouseFire,
  title: "Procédures d'urgence",
  link: "",
};
export const emergencyDoc: LinkContent = {
  faLogo: faFileShield,
  title: "Théorie urgence",
  link: "",
};
export const posteGeneral: LinkContent = {
  faLogo: faCircleInfo,
  title: "Fiche Générale 2025",
  link: "",
};
export const posteAgent: LinkContent = {
  faLogo: faFingerprint,
  title: "Fiche Agent 2025",
  link: "",
};
export const posteStaffs: LinkContent = {
  faLogo: faClipboardUser,
  title: "Fiche Staff 2025",
  link: "",
};
export const docDesPortes: LinkContent = {
  faLogo: faDoorOpen,
  title: "DocDesPortes 2025",
  link: "",
};
export const devisAgent: LinkContent = {
  faLogo: faPersonMilitaryPointing,
  title: "Agents devis",
  link: "",
};

/**** Promotion ****/
export const planningPublication: LinkContent = {
  faLogo: faMessage,
  title: "Planning publication 2026",
  link: "https://docs.google.com/spreadsheets/d/10d3_7-56Xd1RUy3PsidDIrEmuS0OhEiqoGkKt2wS394/",
};

/**** Présidence ****/
export const contratASigner: LinkContent = {
  faLogo: faSignature,
  title: "Contrats à signer",
  link: "https://drive.google.com/drive/folders/1SZPf0JoJhN-X6zcZOOqit00gUsuIRrH5",
};

// Finances
export const encaissementCash: LinkContent = {
  faLogo: faMoneyBill1Wave,
  title: "Encaissement Cash",
  link: "https://docs.google.com/spreadsheets/d/1L75WULZVdcqQAR9knjro3GTtY2_3dM4ZAj7iivj6hQw/",
};
export const budget: LinkContent = {
  faLogo: faScaleBalanced,
  title: "Budget 2026",
  link: "https://docs.google.com/spreadsheets/d/1Obf6Ob9ZkHO0eyAZNumr4ZEL00mX2Y3SiOtDsdCH81c",
};
export const dossierTresorerie: LinkContent = {
  faLogo: faSackDollar,
  title: "Trésorerie 2026 (dossier)",
  link: "https://drive.google.com/drive/folders/191_TXhvYQ7bd07aLEjVG9Lvza5ugcekV",
};
export const suiviPaiements: LinkContent = {
  faLogo: faMoneyBillTransfer,
  title: "Suivit des paiements",
  link: "https://docs.google.com/spreadsheets/d/1lNGQLPZCnjutGIuZ2GChK-IKTkWlbFWrCe5JPIZWyiA",
};
export const justificatifsATraiter: LinkContent = {
  faLogo: faFileInvoiceDollar,
  title: "Justificatifs à traiter",
  link: "https://drive.google.com/drive/folders/1t9zAaKbaCc-aHjxetQaOHihLtIaOLGqt?usp=drive_link",
};
export const demandeArgent: LinkContent = {
  faLogo: faCommentDollar,
  title: "Demande d'argent",
  link: "https://docs.google.com/document/d/1qvAPXZsw4ckgfJdlnYPryda5Mo6MJ6CQBwi87ytAykc",
};

// PC
export const folderPC: LinkContent = {
  faLogo: faWalkieTalkie,
  title: "PC 2025",
  link: "",
};
